import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const modal = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.value = action.payload
    },
    closeModal(state) {
      state.value = initialState.value
    }
  }
})

export const { openModal, closeModal } = modal.actions

export default modal.reducer
